import logger from '@finn-no/fiaas-logger';
import type { GetServerSidePropsContext, NextPage } from 'next';
import { useConfig } from 'shared/config/ConfigContext';
import { Head } from 'shared/page/Head';
import { Main } from 'shared/page/Main';
import type { DeviceType } from 'shared/types';
import { Hotjar } from 'shared/util/hotjar';
import { fetchSearchId } from '@/api/apiInternal';
import { FavoriteApiProvider } from '@/context/FavoriteApiProvider';
import type { FhhUnleashToggles } from '@/domain';
import { ToastProvider } from '@/scenes/resultPage/context/toast/ToastProvider';
import { ResultPage } from '@/scenes/resultPage/ResultPage';

import { clientConfig } from '@/server/config';
import { buildCommonProps, sanitizeCommonProps } from '@/server/middleware';

interface ResultatProps {
    deviceType: DeviceType;
    loginId: number;
    unleash: FhhUnleashToggles;
    hasLegalBasis: boolean;
    searchId: string | null;
}

const Result: NextPage<ResultatProps> = (props) => {
    const { baseUrl } = useConfig();

    return (
        <>
            <Head
                title="Feriehjem og hytter - sammenlign pris | FINN reise"
                description="Finn tusenvis av feriehjem og hytter på et sted!"
                canonical={`${baseUrl}/reise/feriehus-hytteutleie/resultat/`}
            />
            <Main broadcastUrl="/broadcasts?path=www.finn.no/reise/feriehus-hytteutleie">
                <FavoriteApiProvider loginId={props.loginId}>
                    <ToastProvider>
                        <ResultPage {...props} searchId={props.searchId} />
                    </ToastProvider>
                </FavoriteApiProvider>
            </Main>
            <Hotjar enabled={Boolean(props.unleash?.hotjarResultList && props.hasLegalBasis)} />
        </>
    );
};

export const getServerSideProps = async ({ req, res, query }: GetServerSidePropsContext) => {
    const commonProps = await buildCommonProps(req, res, query);

    let searchId = null;

    if (commonProps.unleash?.newSearch && query.booking_from && query.booking_to && query.no_of_beds_from) {
        const search = await fetchSearchId(query)
            .then((response) => response)
            .catch((err) => logger.error(err));
        searchId = search.searchId;
    }

    return {
        props: { config: clientConfig, ...sanitizeCommonProps(commonProps), searchId: searchId ?? null },
    };
};

export default Result;
